import { normalizeBalanceExpireMmyy } from './card-fill-balance-expire';

/** UZ card BINs used for full-PAN detection (parity with back card-display). */
export const CARD_BALANCE_FETCH_BINS = ['9860', '8600', '5416', '6262', '4073', '4040'] as const;

export function isLuhnValid(value: string): boolean {
	const digits = value.replace(/\D/g, '');
	if (digits.length < 2) return false;

	let sum = 0;
	for (let i = 0; i < digits.length; i++) {
		let n = Number(digits[digits.length - 1 - i]);
		if (i % 2 === 1) {
			n *= 2;
			if (n > 9) n -= 9;
		}
		sum += n;
	}
	return sum % 10 === 0;
}

export function isValidUzCardBin(cardNumber: string): boolean {
	const digits = cardNumber.replace(/\D/g, '');
	return digits.length === 16 && CARD_BALANCE_FETCH_BINS.some(bin => digits.startsWith(bin));
}

export function isLikelyFullCardPan(value: string | null | undefined): boolean {
	if (!value?.trim()) return false;
	return isValidUzCardBin(value) && isLuhnValid(value);
}

export function isCardBalanceFetchReady(card: {
	number?: string | null;
	date?: string | null;
	phoneId?: number | null;
}): boolean {
	if (!isLikelyFullCardPan(card.number ?? undefined)) {
		return false;
	}
	if (!card.date?.trim()) {
		return false;
	}
	if (!normalizeBalanceExpireMmyy(card.date)) {
		return false;
	}
	return card.phoneId != null;
}
